import { render } from "./SortDropdown.vue?vue&type=template&id=6d49bef4&scoped=true"
import script from "./SortDropdown.vue?vue&type=script&lang=js"
export * from "./SortDropdown.vue?vue&type=script&lang=js"

import "./SortDropdown.vue?vue&type=style&index=0&id=6d49bef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d49bef4"]])

export default __exports__